import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Bank({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.5288 1.52839C11.7891 1.26804 12.2112 1.26804 12.4716 1.52839L20.2763 9.33313H22.6668V10.6665H1.3335V9.33313H3.72402L11.5288 1.52839ZM18.3907 9.33313L12.0002 2.94261L5.60964 9.33313H18.3907Z"
        fill={iconColor}
      />
      <Path
        d="M20.6668 19.9998H22.6668V21.3331H1.3335V19.9998H3.3335V11.9998H4.66683V19.9998H7.3335V11.9998H8.66683V19.9998H11.3335V11.9998H12.6668V19.9998H15.3335V11.9998H16.6668V19.9998H19.3335V11.9998H20.6668V19.9998Z"
        fill={iconColor}
      />
    </Svg>
  );
}
